import defaultTheme from '../assets/json/themes/default.json'
import aeroTheme from '../assets/json/themes/aero.json'
import rvTheme from '../assets/json/themes/rv.json'
import cycleTheme from '../assets/json/themes/cycle.json'
import truckTheme from '../assets/json/themes/truck.json'
import boatTheme from '../assets/json/themes/boat.json'
import equipmentTheme from '../assets/json/themes/equipment.json'
import nxtTheme from '../assets/json/themes/nxt.json'
import radTheme from '../assets/json/themes/rad.json'
import platformTheme from '../assets/json/themes/platform.json'
import atvTheme from '../assets/json/themes/atv.json'
import pwcTheme from '../assets/json/themes/pwc.json'
import snowTheme from '../assets/json/themes/snow.json'

export default class ThemeUtil {
  constructor() {
    this.themeId = null
    this.activeTheme = null
    this.overrides = null
  }

  getBlankTheme() {
    return {
      theme: '',
      header: {
        text: {
          value: '',
          color: '',
        },
        logo: {
          color: '',
          src: '',
          radius: '',
          show: false,
        },
        backgroundColor: '',
      },
      buttons: {
        launcher: {
          backgroundColor: '',
          logoColor: '',
          mobileDisplay: 'true',
        },
        submit: {
          backgroundColor: '',
          borderColor: '',
          textColor: '',
          spinnerColor: '',
        },
      },
      chat: {
        bubble: {
          dealer: {
            backgroundColor: '',
            textColor: '',
          },
          user: {
            backgroundColor: '',
            textColor: '',
          },
        },
        initialMessage: {
          value: '',
        },
      },
    }
  }

  getThemes() {
    return {
      default: defaultTheme,
      aero: aeroTheme,
      rv: rvTheme,
      cycle: cycleTheme,
      truck: truckTheme,
      boat: boatTheme,
      equipment: equipmentTheme,
      nxt: nxtTheme,
      rad: radTheme,
      platform: platformTheme,
      atv: atvTheme,
      pwc: pwcTheme,
      snow: snowTheme,
    }
  }

  getActiveTheme() {
    if (!this.themeId) {
      return null
    }

    return this.activeTheme
  }

  setActiveTheme(themeId) {
    this.themeId = themeId
    this.activeTheme = this.getThemes()[themeId]
  }

  setThemeOverrides(overrides) {
    this.overrides = overrides
    this.activeTheme = this.mergeThemes(this.activeTheme, this.overrides)
  }

  mergeThemes(baseTheme, priorityTheme) {
    let mergedObject = baseTheme

    for (const [address, value] of Object.entries(priorityTheme)) {
      if (typeof value === 'object') {
        mergedObject[address] = this.mergeThemes(baseTheme[address], priorityTheme[address])
      }
      if (typeof value !== 'object' && value !== '') {
        mergedObject[address] = value
      }
    }

    return mergedObject
  }
}
